import { Button, useMutation, useNotify } from "react-admin";
import React, { useMemo } from "react";

import SendOutlinedIcon from "@material-ui/icons/SendOutlined";

const NotifyResearcherButton = ({
  record,
  source = "id",
  visible = (record) =>
    record?.id > 0 && record?.roles?.some((r) => r.code === "researcher"),
}) => {
  const notify = useNotify();
  const [send, { loading }] = useMutation(
    {
      type: "post",
      resource: "users/notify-researcher",
      payload: { id: record?.[source] },
    },
    {
      onSuccess: () => notify("resources.users.actions.notify_researcher.done"),
      onFailure: () =>
        notify("resources.users.actions.notify_researcher.error", "warning"),
    }
  );
  const isVisible = useMemo(() => visible(record), [record, visible]);
  return isVisible ? (
    <Button
      color="primary"
      label="resources.users.actions.notify_researcher"
      disabled={loading}
      onClick={send}
    >
      <SendOutlinedIcon />
    </Button>
  ) : null;
};

export default NotifyResearcherButton;
